import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDowniOs({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.588l-8.293-8.295a1 1 0 10-1.414 1.414l9 9.002a.997.997 0 001.414 0l9-9.002a1 1 0 10-1.414-1.414L12 19.588z"
        fill={color}
      />
    </svg>
  )
}

export default SvgDowniOs
